import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { Container } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import NotFoundPage from '../pages/error/404'
import Dashboard from '../pages/Dashboard'
import Logs from '../pages/admin/Logs'
import Chatbot from '../pages/Chatbot'
import Users from '../pages/admin/Users'
import Documents from '../pages/manager/Documents'
import Odoo from '../pages/Odoo'
import DocumentsForm from '../components/forms/DocumentsForm'
import { useAuth } from '../components/auth/useAuth'
import Sidebar from '../components/menus/Sidebar'
import Topbar from '../components/menus/Topbar'

export default function AdminRouter() {
	const { clientauth } = useAuth()
	const { t } = useTranslation()

	return (
		<Container fluid className='d-flex p-0'>
			<Sidebar rol={clientauth?.rol} />
			<Container fluid className="p-0">
				<Topbar rol={clientauth?.rol} />

				<Routes>
					<Route path={`/${t('url.dashboard')}`} element={<Dashboard />} />
					<Route path="/logs" element={<Logs />} />

					<Route path={`/${t('url.users')}`} element={<Users />} />
					<Route path={`/${t('url.chatbot')}`} element={<Chatbot />} />

					<Route path={`/${t('url.documentsManagement')}`} element={<Documents />} />
					<Route path={`/${t('url.documentsManagement')}/create`} element={<DocumentsForm />} />
					<Route path={`/${t('url.documentsManagement')}/edit/:id`} element={<DocumentsForm />} />

					<Route path={`/${t('url.odoo')}`} element={<Odoo />} />

					<Route path="*" element={<NotFoundPage />} />
				</Routes>
			</Container>
		</Container>
	)
}